export default "__VITE_ASSET__djXLRkQw__"